import { useEffect, useState, useCallback } from 'react'
import { withRouter } from '../utils'
import axios from 'axios'

const COUNTRIES = ["Saudi Arabia","United Arab Emirates","Qatar","Bahrain","Kuwait","Oman","Iraq","Iran","Israel","Palestine","Lebanon","Syria","Yemen","Jordan","Egypt","Turkey","Libya","Sudan","South Sudan","Somalia","Afghanistan","Pakistan","Ukraine","Russia","Myanmar","Ethiopia","Nigeria","Mali","Burkina Faso","Niger","Chad","DR Congo","Mozambique","Eritrea","Cameroon","Central African Republic","Tunisia","Algeria","Morocco","India","Bangladesh","Sri Lanka","China","Taiwan","North Korea","South Korea","Philippines","Indonesia","Thailand","Mexico","Colombia","Venezuela","Haiti","Ecuador","Honduras","El Salvador","Guatemala","Brazil","Peru","Georgia","Moldova","Armenia","Azerbaijan","Serbia","Kosovo","Bosnia and Herzegovina"]

function InviteTeam({ navigate }) {
  const apiHost = process.env.REACT_APP_APIHOST || 'http://localhost:3033'
  const [members, setMembers] = useState([])
  const [me, setMe] = useState(null)
  const [showForm, setShowForm] = useState(false)
  const [form, setForm] = useState({ firstName:'', lastName:'', email:'', company:'', title:'' })
  const [sending, setSending] = useState(false)
  const [toast, setToast] = useState(null)
  const notify = useCallback((msg, type) => { setToast({ msg, type }); setTimeout(() => setToast(null), 3500) }, [])

  useEffect(() => {
    const token = localStorage.getItem('token')
    if (!token) { navigate('/login'); return }
    try {
      const payload = JSON.parse(atob(token.split('.')[1]))
      axios.get(apiHost + '/users/' + payload.id).then(res => { if (res.data.status) { setMe(res.data.data); setForm(f => ({...f, company: res.data.data.company || ''})) } })
    } catch(e) { navigate('/login') }
  }, [apiHost, navigate])

  useEffect(() => {
    if (me) fetchMembers()
  }, [me])

  const fetchMembers = () => {
    axios.get(apiHost + '/users').then(res => {
      if (res.data.status && me) {
        // Show ONLY users that I personally invited
        setMembers(res.data.data.filter(u =>
          u.invitedBy && u.invitedBy.firstName === me.firstName && u.invitedBy.lastName === me.lastName
        ))
      }
    })
  }

  const invite = async () => {
    if (!form.firstName || !form.lastName || !form.email) return notify('First name, last name and email required.', 'warn')
    setSending(true)
    try {
      const res = await axios.post(apiHost + '/invite', {
        firstName: form.firstName, lastName: form.lastName, email: form.email,
        company: form.company || (me ? me.company : ''), title: form.title,
        geographicalCoverage: me ? me.geographicalCoverage : [],
        invitedBy: me ? { firstName: me.firstName, lastName: me.lastName, company: me.company || '' } : null
      })
      if (res.data.status) {
        notify('Invitation sent to ' + form.email, 'ok')
        setForm({ firstName:'', lastName:'', email:'', company:'', title:'' })
        setShowForm(false)
        fetchMembers()
      }
    } catch(e) { notify(e?.response?.data?.errorMessage || 'Failed.', 'err') }
    setSending(false)
  }

  const s = { background:'#141414',color:'#e6e6e6',minHeight:'100vh',fontFamily:'Inter,sans-serif' }
  const card = { background:'#1a1a1a',border:'1px solid rgba(255,255,255,0.06)',borderRadius:4,padding:'20px 24px',marginBottom:12 }
  const inp = { width:'100%',background:'#111',border:'1px solid rgba(255,255,255,0.1)',borderRadius:3,padding:'10px 14px',color:'#e6e6e6',fontSize:13,outline:'none',boxSizing:'border-box' }
  const lbl = { fontSize:10,color:'#888',textTransform:'uppercase',letterSpacing:1,marginBottom:4,display:'block' }
  const btn = { background:'#C29717',color:'#fff',border:'none',borderRadius:3,padding:'10px 24px',fontSize:12,fontWeight:600,cursor:'pointer' }
  const row = { display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:12 }

  return (
    <div style={s}>
      {/* Header */}
      <div style={{ padding:'16px 24px',borderBottom:'1px solid rgba(255,255,255,0.06)',display:'flex',justifyContent:'space-between',alignItems:'center' }}>
        <img src="/icons/logo.webp" alt="FORTE" style={{ height:16,opacity:0.85 }} />
        <svg onClick={() => navigate(-1)} style={{ cursor:'pointer',opacity:0.5 }} width={20} height={20} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </div>

      <div style={{ maxWidth:680,margin:'0 auto',padding:'40px 20px' }}>
        <div style={{ display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:24 }}>
          <div>
            <div style={{ fontSize:9,color:'#C29717',textTransform:'uppercase',letterSpacing:2 }}>Team</div>
            <div style={{ fontSize:20,fontWeight:500 }}>Invite team members</div>
          </div>
          <div style={{ display:'flex',gap:8 }}>
            <span onClick={() => setShowForm(!showForm)} style={{ fontSize:11,color:'#C29717',cursor:'pointer',border:'1px solid rgba(194,151,23,0.3)',borderRadius:3,padding:'6px 14px' }}>{showForm ? 'Cancel' : '+ Invite'}</span>
          </div>
        </div>

        {showForm && (
          <div style={{...card,borderLeft:'3px solid #C29717'}}>
            <div style={{ fontSize:12,fontWeight:600,marginBottom:16,color:'#C29717' }}>New invitation</div>
            <div style={row}>
              <div><label style={lbl}>First name *</label><input style={inp} value={form.firstName} onChange={e => setForm({...form,firstName:e.target.value})} /></div>
              <div><label style={lbl}>Last name *</label><input style={inp} value={form.lastName} onChange={e => setForm({...form,lastName:e.target.value})} /></div>
            </div>
            <div style={row}>
              <div><label style={lbl}>Email *</label><input style={inp} type="email" value={form.email} onChange={e => setForm({...form,email:e.target.value})} /></div>
              <div><label style={lbl}>Company</label><input style={inp} value={form.company} onChange={e => setForm({...form,company:e.target.value})} /></div>
            </div>
            <div style={{ marginBottom:12 }}>
              <label style={lbl}>Title</label><input style={inp} value={form.title} onChange={e => setForm({...form,title:e.target.value})} />
            </div>
            <button style={btn} onClick={invite} disabled={sending}>{sending ? 'Sending...' : 'Send invitation'}</button>
          </div>
        )}

        <div style={{ fontSize:11,color:'#888',marginBottom:8 }}>{members.length} team member{members.length !== 1 ? 's' : ''}</div>
        {members.map(m => (
          <div key={m._id} style={{...card,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div>
              <div style={{ fontSize:13,fontWeight:500 }}>{m.firstName} {m.lastName}</div>
              <div style={{ fontSize:11,color:'#888' }}>{m.email}{m.company ? ' — ' + m.company : ''}{m.title ? ' · ' + m.title : ''}</div>
              {m.invitedBy && <div style={{ fontSize:9,color:'#555',marginTop:2 }}>Invited by {m.invitedBy.firstName} {(m.invitedBy.lastName||'').charAt(0)}.</div>}
            </div>
            <div style={{ display:'flex',alignItems:'center',gap:8 }}>
              {m.inviteToken && <span style={{ fontSize:9,color:'#e88a2a',border:'1px solid rgba(232,138,42,0.3)',borderRadius:2,padding:'2px 6px' }}>pending</span>}
              {!m.inviteToken && m.password && <span style={{ fontSize:9,color:'#4CAF50',border:'1px solid rgba(76,175,80,0.3)',borderRadius:2,padding:'2px 6px' }}>active</span>}
              <span style={{ fontSize:10,color:'#555' }}>{m.geographicalCoverage?.map(g=>g.country).join(', ')}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Toast */}
      {toast && (
        <div style={{ position:'fixed',bottom:24,left:'50%',transform:'translateX(-50%)',background:'#1a1a1a',border:'1px solid ' + (toast.type==='ok'?'rgba(76,175,80,0.3)':toast.type==='err'?'rgba(229,85,85,0.3)':'rgba(194,151,23,0.3)'),borderRadius:4,padding:'12px 24px',fontSize:13,color:toast.type==='ok'?'#4CAF50':toast.type==='err'?'#e55':'#C29717',zIndex:99999,boxShadow:'0 8px 24px rgba(0,0,0,0.5)',animation:'fadeIn 0.2s' }}>{toast.msg}</div>
      )}
    </div>
  )
}
export default withRouter(InviteTeam)
